import * as React from 'react'
import { PageSection } from '@patternfly/react-core'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import GenericCard from 'src/frontend/app/components/GenericCard'
import GenericInput from 'src/frontend/app/components/Form/Input'
import { PATH_TO_BO_CREA_PROROGA, PATH_TO_BO_LISTA_ISCRITTI_ORDINE } from 'src/app/utils/RoutesConstants'
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'design-react-kit'
import { createFormData, handleChangeFormData } from 'src/app/utils/form-utils'
import GenericSelect from 'src/frontend/app/components/Form/Select'
import { getDefaultAxiosConfig, getFormazioneResourceApi } from 'src/app/utils/ManagerRestGateway'
import { Deroga } from '@parsec/msfo'

/* ----------------------------------- VARIABILI E COSTANTI ----------------------------------------- */
const title = 'Crea Proroga'
export const TRIENNI_OPTIONS = [
  { label: '2026-2028', value: 675, firstyear: 2026, lastYear: 2028 },
  { label: '2023-2025', value: 674, firstyear: 2023, lastYear: 2025 },
  { label: '2020-2022', value: 673, firstyear: 2020, lastYear: 2022 },
  { label: '2017-2019', value: 672, firstyear: 2017, lastYear: 2019 },
  { label: '2013-2016', value: 671, firstyear: 2013, lastYear: 2016 },
  { label: '2010-2012', value: 670, firstyear: 2010, lastYear: 2012 },
  { label: '2009', value: 669, firstyear: 2009, lastYear: 2009 },
]

const rules = {
  triennio: {
    isRequired: true,
  },
  provvedimento: {
    isRequired: true,
  },
  dataInizioDeroga: {
    isRequired: true,
    _custom: {
      check: (code, rule, data) => {
        if (!data?.triennio || !data?.dataInizioDeroga) return true

        const dataInizio = new Date(data.dataInizioDeroga)
        const dataMinima = new Date(`${data.triennio.firstyear}-01-01`)

        return dataInizio >= dataMinima
      },
      message: (data) => `La data inizio proroga non può essere antecedente al 01/01/${data.triennio.firstyear}`,
    },
  },
  dataFineDeroga: {
    isRequired: true,
    _custom: {
      check: (code, rule, data) => {
        if (!data?.dataInizioDeroga || !data?.dataFineDeroga) return true

        const start = new Date(data.dataInizioDeroga)
        const end = new Date(data.dataFineDeroga)

        if (isNaN(start.getTime()) || isNaN(end.getTime())) return false

        return end > start
      },
      message: () => 'La data di fine proroga deve essere successiva alla data di inizio proroga',
    },
  },
}

const Spacer = () => <br></br>

const CreaProroga: React.FunctionComponent<any> = (props) => {
  const user = props.location?.state?.user
  const refForm = React.useRef<any>([])
  const [data, setData] = React.useState<any>({})
  const [showModal, setShowModal] = React.useState<any>({ open: false, message: '', ok: false })
  const [errors, setErrors] = React.useState<any>({})
  const [loading, setLoading] = React.useState(false)

  const formData = createFormData(data, setData, errors, setErrors)

  const isFormValid = React.useMemo(() => {
    return (
      data.triennio &&
      data.dataInizioDeroga &&
      data.dataFineDeroga &&
      data.provvedimento &&
      !errors.triennio &&
      !errors.dataInizioDeroga &&
      !errors.dataFineDeroga
    )
  }, [data, errors])

  const onInitInput = (cmp, tab) => {
    refForm.current.push({
      tab: 0,
      cmp: cmp,
    })
  }

  const handleInput = (cod: string, val: string) => {
    handleChangeFormData(formData, cod, val, rules)

    if (cod === 'triennio') {
      handleChangeFormData(formData, 'concessa_al', null, rules)
      handleChangeFormData(formData, 'dataInizioDeroga', data.dataInizioDeroga, rules)
      handleChangeFormData(formData, 'dataFineDeroga', data.dataFineDeroga, rules)
    }

    if (cod === 'dataInizioDeroga') {
      handleChangeFormData(formData, 'dataFineDeroga', data.dataFineDeroga, rules)
    }

    if (cod === 'dataFineDeroga') {
      handleChangeFormData(formData, 'dataInizioDeroga', data.dataInizioDeroga, rules)
    }
  }

  const concediDerogaUtente = async (triennio, dataInizio, dataFine, provvedimento, user) => {
    if (!triennio || !dataInizio || !dataFine || !user) return

    let messaggio = {
      head: 'Errore sulla concessione della proroga.',
      data: [],
    }

    let ok = false
    setLoading(true)
    try {
      const start = new Date(dataInizio)
      const end = new Date(dataFine)

      if (end <= start) {
        setLoading(false)
        setShowModal({
          open: true,
          ok: false,
          message: {
            head: 'Errore validazione date',
            data: ['La data fine deve essere maggiore della data inizio'],
          },
        })
        return
      }

      const payload: Deroga = {
        cf: user.cf,
        triennio: triennio.value,
        dataInizioDeroga: dataInizio,
        dataFineDeroga: dataFine,
        idIscr: user.id_iscrizione,
        provvedimento,
      }

      const result = await getFormazioneResourceApi().msfoFormazioneCreaDerogaPost(payload, getDefaultAxiosConfig())
      messaggio.head = result.data.message
      if (result.data.status == 0) {
        ok = true
      } else {
        ok = false
      }
    } catch (e: any) {
      console.error(e)
    } finally {
      setLoading(false)
    }

    setShowModal({
      open: true,
      message: messaggio,
      ok,
    })
  }

  const onCloseModal = () => {
    if (showModal.ok) props.history.push(PATH_TO_BO_LISTA_ISCRITTI_ORDINE)
    setShowModal({ open: false })
  }

  const breadcrumbOptions = [
    { label: 'Concessione proroghe', link: PATH_TO_BO_LISTA_ISCRITTI_ORDINE },
    { label: 'Concedi proroga ' + user.cf, link: PATH_TO_BO_CREA_PROROGA },
  ]
  return (
    <PageSection id="pageSectionId">
      <div className="container register-container">
        <GenericBreadCrumb paths={breadcrumbOptions}></GenericBreadCrumb>
        <div>
          <h1>{title}</h1>
        </div>
        <GenericCard cardHeader={`Concessione proroga per ${user.nome} ${user.cognome}`}>
          {' '}
          <Form>
            <div className="row">
              <div className="col-6">
                <GenericSelect
                  id="triennio"
                  label="Triennio di destinazione dei CFP"
                  defaultOptions={TRIENNI_OPTIONS}
                  value={data.triennio}
                  onChange={handleInput}
                  onInit={onInitInput}
                  errorMessage={errors?.triennio}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <GenericInput
                  isDisabled={!data.triennio}
                  id="dataInizioDeroga"
                  type="date"
                  label="Data inizio proroga *"
                  value={data.dataInizioDeroga}
                  onChange={handleInput}
                  onInit={onInitInput}
                  errorMessage={errors?.dataInizioDeroga}
                  onKeyDown={() => {}}
                />
              </div>

              <div className="col-6">
                <GenericInput
                  isDisabled={!data.triennio}
                  id="dataFineDeroga"
                  type="date"
                  label="Data fine proroga *"
                  value={data.dataFineDeroga}
                  onChange={handleInput}
                  onInit={onInitInput}
                  errorMessage={errors?.dataFineDeroga}
                  onKeyDown={() => {}}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <GenericInput
                  isDisabled={!data.triennio}
                  id="provvedimento"
                  type="text"
                  label="Provvedimento di concessione *"
                  value={data.provvedimento}
                  onInit={onInitInput}
                  onChange={handleInput}
                  errorMessage={errors?.provvedimento}
                />
              </div>
            </div>
          </Form>
          <Button
            onClick={() => concediDerogaUtente(data.triennio, data.dataInizioDeroga, data.dataFineDeroga, data.provvedimento, user)}
            disabled={loading || !isFormValid}
            color="primary"
          >
            {loading ? (
              <span className="d-flex align-items-center gap-2">
                <span className="spinner-border spinner-border-sm" role="status" />
                Ripartizione automatica in corso ...
              </span>
            ) : (
              'Concedi proroga'
            )}
          </Button>
          {showModal.open && (
            <Modal fade centered isOpen={showModal.open} toggle={onCloseModal}>
              <ModalHeader style={{ fontSize: '25px' }} id="isDerogaConcessa">
                Concessione proroga
              </ModalHeader>
              <ModalBody>
                <p>{showModal.message.head}</p>
                <Spacer />
                {showModal.message.data.map((dato) => (
                  <div>
                    <p>{dato}</p>
                    <Spacer />
                  </div>
                ))}
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={onCloseModal}>
                  OK
                </Button>
              </ModalFooter>
            </Modal>
          )}
          <br />
          <br />
          <p style={{ margin: 0 }}>• La data di inizio proroga non può essere antecedente al primo giorno del triennio selezionato.</p>
          <p style={{ margin: 0 }}>• La data di fine proroga deve essere successiva alla data di inizio.</p>
        </GenericCard>
      </div>
    </PageSection>
  )
}

export default CreaProroga
